import type { ButtonHTMLAttributes, ReactNode } from "react";

interface FilterChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  icon?: ReactNode;
}

const FilterChip = ({
  active = false,
  icon,
  className = "",
  children,
  type = "button",
  ...rest
}: FilterChipProps): JSX.Element => {
  return (
    <button
      type={type}
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full px-4 py-2 text-xs font-semibold transition-colors ${
        active
          ? "bg-brand-500 text-white shadow-sm shadow-brand-500/20"
          : "border border-line bg-surface text-gray-600 hover:bg-surface-hover dark:text-gray-300"
      } ${className}`.trim()}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
};

export default FilterChip;
